(() => {
  if (window.nxoPochitaBooted) return;
  window.nxoPochitaBooted = true;
  const blockedSelector = '.menu-drawer-container[open],cart-drawer.active,.Vtl-CartDrawer__Container--IsVisible,details-modal details[open],.product-popup-modal[open],dialog[open]';
  const storageKey = 'nexo.pochita.v1';
  let instance;
  function mount() {
    const root = document.querySelector('[data-nxo-pochita]');
    if (!root || instance?.root === root) return;
    instance?.destroy();
    const avatar = root.querySelector('.nxo-pochita__avatar');
    const bubble = root.querySelector('.nxo-pochita__bubble');
    const message = root.querySelector('.nxo-pochita__message');
    const close = root.querySelector('.nxo-pochita__close');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    let state = { active: 0, spoken: false, dismissed: false, saw: false };
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved && typeof saved.active === 'number') state = { ...state, ...saved };
    } catch {}
    let pageActive = 0;
    let lastTick = performance.now();
    let lastScroll = -Infinity;
    let sizeDue = null;
    let bubbleUntil = null;
    let animationTimer;
    let animationVersion = 0;
    let animationRunning = false;
    let busy = false;
    let sizeModal = null;
    let wasSizeOpen = false;
    let pendingCart = 0;
    let cartReadyAt = 0;
    let cartFeedback = null;
    let cartFeedbackImage = null;
    let cartFeedbackUntil = 0;
    let cartFeedbackTimer;
    const images = new Map();
    const persist = () => {
      try { sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch {}
    };
    const hidden = () => document.hidden || !!document.querySelector(blockedSelector);
    const quietPose = () => {
      animationVersion += 1;
      clearTimeout(animationTimer);
      avatar.src = root.dataset.idle;
      animationRunning = false;
      busy = false;
      delete root.dataset.animating;
    };
    const hideBubble = () => {
      bubble.hidden = true;
      message.textContent = '';
      bubbleUntil = null;
      delete root.dataset.speaking;
    };
    const clearCartFeedback = () => {
      clearTimeout(cartFeedbackTimer);
      if (cartFeedbackImage) {
        cartFeedbackImage.src = root.dataset.idle;
        delete cartFeedbackImage.dataset.animating;
      }
      cartFeedback?.remove();
      cartFeedback = null;
      cartFeedbackImage = null;
      cartFeedbackUntil = 0;
    };
    const cartFeedbackTarget = () => {
      const target = document.querySelector('.Vtl-CartDrawer__Container--IsVisible,cart-drawer.active .drawer__inner');
      if (!target || target.getBoundingClientRect().width === 0) return null;
      return target.querySelector('[data-nxo-cart-guide]') || target.querySelector('.Vtl-CartDrawerHeader,.drawer__header');
    };
    const showCartFeedback = (header, now) => {
      clearCartFeedback();
      const inline = header.matches?.('[data-nxo-cart-guide]');
      const note = document.createElement('aside');
      note.className = inline ? 'nxo-cart-feedback nxo-cart-feedback--inline' : 'nxo-cart-feedback';
      const image = inline ? header.querySelector('[data-nxo-cart-avatar]') : document.createElement('img');
      image.width = 64;
      image.height = 64;
      image.alt = '';
      image.src = motion.matches ? root.dataset.idle : root.dataset.animationCarrito;
      if (!motion.matches) {
        note.dataset.animating = 'carrito';
        image.dataset.animating = 'carrito';
      }
      const text = document.createElement('p');
      text.setAttribute('role', 'status');
      text.setAttribute('aria-live', 'polite');
      text.setAttribute('aria-atomic', 'true');
      if (inline) {
        note.append(text);
        header.querySelector('[data-nxo-cart-reaction]').append(note);
      } else {
        note.append(image, text);
        header.after(note);
      }
      text.textContent = root.dataset.messageCarrito;
      cartFeedback = note;
      cartFeedbackImage = image;
      cartFeedbackUntil = now + 4000;
      cartFeedbackTimer = setTimeout(() => {
        if (cartFeedback !== note) return;
        image.src = root.dataset.idle;
        delete image.dataset.animating;
        delete note.dataset.animating;
      }, 850);
    };
    const showBubble = (kind) => {
      const cartReaction = kind === 'carrito';
      if ((!cartReaction && (state.spoken || state.dismissed)) || hidden()) return false;
      if (!cartReaction) { state.spoken = true; persist(); }
      message.textContent = root.dataset[`message${kind[0].toUpperCase()}${kind.slice(1)}`];
      bubble.hidden = false;
      root.dataset.speaking = kind;
      bubbleUntil = pageActive + (cartReaction ? 2600 : 6000);
      return true;
    };
    async function play(kind, withBubble = false) {
      if (busy || (state.dismissed && kind !== 'carrito') || hidden()) return;
      if (withBubble && kind !== 'carrito' && state.spoken) return;
      if (motion.matches) {
        if (withBubble) showBubble(kind);
        if (kind === 'sierra') { state.saw = true; persist(); }
        return;
      }
      busy = true;
      const version = ++animationVersion;
      const assetKind = kind === 'tallas' ? 'ayuda' : kind;
      const src = root.dataset[`animation${assetKind[0].toUpperCase()}${assetKind.slice(1)}`];
      try {
        if (!images.has(src)) {
          const preload = new Image();
          preload.src = src;
          images.set(src, preload.decode());
        }
        await images.get(src);
      } catch {
        if (version === animationVersion) {
          busy = false;
          if (withBubble) showBubble(kind);
          if (kind === 'sierra') { state.saw = true; persist(); }
        }
        return;
      }
      if (version !== animationVersion) return;
      if (hidden() || (state.dismissed && kind !== 'carrito') || (withBubble && kind !== 'carrito' && state.spoken)) { quietPose(); return; }
      if (withBubble && !showBubble(kind)) { quietPose(); return; }
      if (kind === 'sierra') { state.saw = true; persist(); }
      avatar.src = src;
      animationRunning = true;
      root.dataset.animating = kind;
      animationTimer = setTimeout(quietPose, kind === 'carrito' ? 850 : 1550);
    }
    function detectSizeGuide() {
      const open = document.querySelector('.product-popup-modal[open]');
      if (open && open !== sizeModal) {
        const label = `${open.openedBy?.textContent || ''} ${open.querySelector('h1,h2,h3')?.textContent || ''}`;
        if (/tallas|size guide|size chart/i.test(label)) { sizeModal = open; wasSizeOpen = true; }
      }
      if (wasSizeOpen && sizeModal && !sizeModal.hasAttribute('open')) {
        wasSizeOpen = false;
        sizeDue = pageActive + 2500;
      }
      if (sizeModal?.hasAttribute('open')) wasSizeOpen = true;
    }
    function tick() {
      const now = performance.now();
      const delta = Math.max(0, Math.min(now - lastTick, 1500));
      lastTick = now;
      if (!document.hidden) { state.active += delta; pageActive += delta; }
      persist();
      detectSizeGuide();
      if (cartFeedback && (document.hidden || !cartFeedback.isConnected || now >= cartFeedbackUntil)) clearCartFeedback();
      if (!document.hidden && pendingCart > 0 && now >= cartReadyAt) {
        const header = cartFeedbackTarget();
        if (header) {
          pendingCart -= 1;
          quietPose();
          hideBubble();
          showCartFeedback(header, now);
          return;
        }
      }
      if (bubbleUntil !== null && pageActive >= bubbleUntil) hideBubble();
      if (hidden()) {
        if (pendingCart > 0 && !cartFeedbackTarget()) cartReadyAt = now + 650;
        if (animationRunning || busy) quietPose();
        if (bubbleUntil !== null) hideBubble();
        return;
      }
      if (busy) return;
      if (pendingCart > 0 && now >= cartReadyAt && bubbleUntil === null) {
        pendingCart -= 1;
        play('carrito', true);
        return;
      }
      if (state.dismissed) return;
      if (!state.spoken && root.dataset.nuevo === 'true' && pageActive >= 4000) play('nuevo', true);
      else if (!state.spoken && sizeDue !== null && pageActive >= sizeDue) play('tallas', true);
      else if (!state.spoken && sizeDue === null && state.active >= 25000 && now - lastScroll >= 1500) play('ayuda', true);
      else if (!state.saw && state.active >= 65000 && bubbleUntil === null && now - lastScroll >= 1500) play('sierra');
    }
    close.addEventListener('click', () => {
      const restoreFocus = bubble.contains(document.activeElement);
      state.dismissed = true;
      persist();
      hideBubble();
      quietPose();
      clearCartFeedback();
      if (restoreFocus) root.querySelector('.nxo-pochita__link').focus({ preventScroll: true });
    }, { signal: events.signal });
    document.addEventListener('nexo:cart-added', (event) => {
      if (event.detail?.confirmed !== true) return;
      pendingCart += 1;
      cartReadyAt = performance.now() + 900;
      if (root.dataset.speaking !== 'carrito') { quietPose(); hideBubble(); }
    }, { signal: events.signal });
    window.addEventListener('scroll', () => { lastScroll = performance.now(); }, { passive: true, signal: events.signal });
    document.addEventListener('visibilitychange', () => {
      lastTick = performance.now();
      if (document.hidden) { quietPose(); hideBubble(); clearCartFeedback(); }
    }, { signal: events.signal });
    motion.addEventListener('change', () => {
      if (motion.matches) {
        quietPose();
        const image = cartFeedbackImage;
        if (image) image.src = root.dataset.idle;
        if (image) delete image.dataset.animating;
        if (cartFeedback) delete cartFeedback.dataset.animating;
      }
    }, { signal: events.signal });
    window.addEventListener('pagehide', persist, { signal: events.signal });
    const timer = setInterval(tick, 250);
    instance = { root, destroy() { clearInterval(timer); events.abort(); quietPose(); clearCartFeedback(); persist(); } };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => {
    if (instance && !instance.root.isConnected) { instance.destroy(); instance = null; }
  });
})();

